import React from "react"
import FeatureTypeGroups from "./FeatureTypes/FeatureTypeGroups"
import Panel from "./Panel/Panel"
import "./overview.scss"
import Search from "./Searchbar/SearchComponent"
import { Route } from "react-router-dom"

const Overview = () => {
  // There was a defect spinner here to show that a catalog was about to be loaded. Consider implementing it correctly.
  // if (context.fcId === "") {
  //   return <Spinner animation="border" role="status" variant="primary" />
  // }

  return (
    <>
      <Search />
      <div className="featureCatalogViewer">
        <div className="featureTypeGroups">
          <FeatureTypeGroups />
        </div>
        <Route path="/featurecatalogdetails/:catalog/:type/:pid">
          <div className="panel">
            <Panel />
          </div>
        </Route>
      </div>
    </>
  )
}

export default Overview
